export default __webpack_public_path__ + "static/media/lohalogo.e19585d5.webp";